<template>
    <div style="height:100%">
        <div class='b-header'>
            <div class="header-menu">
               <div v-if="$isShowLogo" class="menu-item header-logo"></div>
            </div>
            <div class="header-right">
                <el-select v-model="language" size="mini" placeholder="请选择" popper-class="dark-style">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <span class="time">{{currentTime}}</span>
            </div>
            <div style="clear:both;"></div>
        </div>
        <div class="login-content">
            <!-- <div class="left-bg"></div> -->
            <div class="login-box">
                <div class="title">电力设备状态智能监测系统</div>
                <div class="login-logo"></div>
                <p class='login-title'>欢迎登录</p>
                <el-form :model="formModel" :rules="rules" ref="formModel" class="login-form" label-position="left" label-width="70px">
                    <el-form-item  prop="username" label="账号">
                        <el-input v-model="formModel.username"></el-input>
                    </el-form-item>
                    <el-form-item prop="password"  label="密码">
                        <el-input type='password' v-model="formModel.password" show-password></el-input>
                    </el-form-item>
                </el-form>
                <div class="login-set">
                    <el-checkbox v-model="checked" label="自动登录" style="float:left;color:#468EFF;"></el-checkbox>
                    <span style="float:right;color:#468EFF;cursor:pointer;font-size:14px;">忘记密码</span>
                </div>
                <el-button class="login-btn" style="width:100%;background:#5A5B5C;border:0;color:#fff;" @click="showCaptchaModal">登录</el-button>

            </div>
        </div>
        <el-dialog
            title="安全验证"
            :visible.sync="showCaptcha"
            :close-on-click-modal="false"
            :show-close="true"
            custom-class="captcha-dialog"
            @opened="onCaptchaDialogOpened">
            <div class="captcha-content">
                <div class="captcha-instruction">请依次点击图中文字（点击3个位置）</div>
                <i class="el-icon-refresh-left" @click="resetCaptcha"></i>
                <div class="captcha-container" ref="captchaContainer">
                    <div  style="display: flex;justify-content:space-between; align-items:center">
                          <img id="captcha-img" ref="codeImg" @load="handleImageLoad" @click="handleCaptchaClick">
                    </div>
                    <div class="markers-container">
                        <div v-for="(marker, index) in markers" :key="index" 
                            class="marker" 
                            :style="{ left: `${marker.x}px`, top: `${marker.y}px` }">
                            <span class="marker-label">{{ index + 1 }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="captchaError" class="captcha-error">{{ captchaError }}</div>
            </div>
        </el-dialog>
    </div>
</template>
        <!-- <div class="login-bottom"><el-link href="https://beian.miit.gov.cn" target="_blank">备案号：沪ICP备2024045257号</el-link></div> -->
    </div>
</template>

<script>
import * as account from '@/data/api.js'
import Bus from "@/util/Bus.js";
export default {
  name:'',
  data(){
   return {
       formModel:{
           username:"",
           password:'',
           positions: []
       },
       checked:false,
       rules:{
           username: [
            { required: true, message: '请输入账户名', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
       },
       language:1,
       options:[
            {value:1,label:'简体中文'}
        ],
        currentTime:'',

        codeUrl: null,
        // 验证码相关状态
        showCaptcha: false,
        captchaImageUrl: '', // 验证码图片URL
        positions: [],       // 存储点击坐标
        markers: [],         // 存储标记位置（用于UI）
        imgRect: {},         // 存储图片位置信息
        naturalWidth: 0,      // 图片原始宽度
        naturalHeight: 0,     // 图片原始高度
        isLoading: false,    // 加载状态
        captchaError: '',      // 错误信息
        imageLoading: false, //加载图片
        lastClickTime: 0,
        lastResetTime: 0
   }
  },
   mounted(){
        setInterval(this.timeFormat,1000)
        this.loadCaptchaImage();
    },
  methods: {
       timeFormat(){
                let date = new Date();
                this.currentTime = date.getFullYear()+'-'+(date.getMonth() + 1)+'-'+date.getDate()+" "+date.getHours()+':'+date.getMinutes()
            },
    onCaptchaDialogOpened() {
      // 加载验证码图片
      this.loadCaptchaImage();
    },
    loadCaptchaImage() {
      this.imageLoading = true;
      this.$refs.codeImg.src = `/api/verify_code?&${Math.random()}&username=${this.formModel.username}`;
    },
    // 显示验证码弹框
    showCaptchaModal(){
          this.$refs.formModel.validate(valid => {
            if(valid){
                this.showCaptcha = true;
                this.resetCaptcha();
            }
          })
      },
      
    // 重置验证码状态
    resetCaptcha() {
        const now = Date.now();
        if (now - this.lastResetTime < 300
        ) {
        return;
        }
        this.lastResetTime = now;
          this.positions = [];
          this.markers = [];
          this.formModel.positions = [];
          this.captchaError = '';
          this.isLoading = false;
          
          // 刷新验证码图片
        //   this.captchaImageUrl = '/api/verify_code?' + Math.random();
        this.$refs.codeImg.src = `/api/verify_code?&${Math.random()}&username=${this.formModel.username}`
      },
      
      // 图片加载完成后获取尺寸信息
      handleImageLoad(event) {
      const img = event.target;
      // 确保DOM已更新
      this.$nextTick(() => {
        // 获取图片在页面中的位置和尺寸
        const rect = img.getBoundingClientRect();
        
        // 存储关键信息
        this.naturalWidth = img.naturalWidth;
        this.naturalHeight = img.naturalHeight;
        this.imgRect = {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height
        };
      });
      this.imageLoading = false;
      },
      
      // 处理验证码点击
      handleCaptchaClick(e) {
        const now = Date.now();
        if (now - this.lastClickTime < 300
        ) {
        return;
        }
        this.lastClickTime = now;

          if (this.positions.length >= 3) return;
          
          const clickX = e.clientX;
          const clickY = e.clientY;
          
          // 转换为相对图片容器的坐标
          const relativeX = clickX - this.imgRect.left;
          const relativeY = clickY - this.imgRect.top;
          
          // 转换为原始图片坐标（处理缩放）
          const x = Math.round((relativeX / this.imgRect.width) * this.naturalWidth);
          const y = Math.round((relativeY / this.imgRect.height) * this.naturalHeight);
          
          // 存储坐标
          this.positions.push({ x, y });
          this.markers.push({ x: relativeX, y: relativeY });
          this.formModel.positions.push({ 'x': Math.round(relativeX), 'y': Math.round(relativeY) });
          if (this.positions.length >= 3) {
            this.confirmCaptcha();
          }
      },
      
      // 确认验证码
      confirmCaptcha() {
          this.isLoading = true;
          this.captchaError = '';
          
          this.performLogin();
      },
      
      // 执行登录
      performLogin() {
          account.login(this.formModel).then(res => {
              if(res.code == 0) {
                  localStorage.setItem('userInfo', JSON.stringify(res.data));
                  this.$router.push({ name: 'sum' });
                  Bus.$emit('logined', res.data.id);
                  
                  // 关闭验证码弹框
                  this.showCaptcha = false;
              } else {
                  this.captchaError = res.message || '验证失败，请重试';
                  this.resetCaptcha();
              }
          }).catch(err => {
              this.captchaError = '登录失败，请重试';
              this.resetCaptcha();
          }).finally(() => {
              this.isLoading = false;
          });
      }
  }
}
</script>

<style lang='less' scoped>
    /deep/.el-input__inner{
        border:1px solid #797979;
        color: rgba(79, 76, 76, 1) !important
    }
    .login-content{
        height:calc(100% - 94px);
        // // background:url("~@/assets/bg.png") center center no-repeat;
        background:#212325;
        background-size:100% 100%;
        display: flex;    justify-content:center;align-items:center;
    }
    .login-bottom {
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        text-align: center;
        background-color: #3d3f44;
    }
    .left-bg{
        width:562px;height: 330px;background:url("~@/assets/login-bg.png");
        background-size:100% 100%;border-radius: 10px;;
    }
    .login-box{
        height:550px;width:450px;border-radius:10px;
        // position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;
        text-align: center;padding:40px 50px;box-sizing: border-box;
        .el-form-item{
            margin-bottom: 22px;
        }
        .title{
            font-size: 28px;
            color: #fff;
            margin-bottom: 40px;
        }
    }
    .login-logo{
        width: 50px;height:42px;
        background: url("~@/assets/logo.png");
        margin:0 auto;
        text-align: center;
    }
    .login-title{
        color:#fff;
        margin-top: 15px;font-size: 20px;
    }
    .login-form{
        margin-top:50px;
    }
    .login-set{
        margin-top:20px;
    }
    /deep/.login-set .el-checkbox{
        color:#000;
    }
    .login-btn{
        width:100%;margin-top: 30px;letter-spacing: 5px;font-size: 20px;
    }
    /deep/.el-form-item__label{
        color:#fff;
    }
    .b-header{
        width:100%;height:54px;position: relative;   background:rgb(61,63,68);color:#fff;
        // background:#091335;
    }
    .header-menu{
        height:100%;line-height: 54px;text-align: center;float: left;
        position:absolute;font-size:20px;z-index: 999;left:0;top:0;
    }
    .header-logo{
        width:180px;
        background: url("~@/assets/logo/logo.png") no-repeat center;
        background-size: 94% 94%;
        background-position: 10px 0;
    }
    .menu-item{
        float:left;
        padding:0 15px;height:54px;line-height: 54px;
        cursor: pointer;
    }
    .header-right{
        position: absolute;right:10px;top:0;z-index: 1;
        float:right;height:54px;line-height: 54px;
        i{
            font-size: 18px;
            color:#fff;
        }
        button{
            border:0;background:#3D3F44;cursor: pointer;padding-right:5px;
        }
        /deep/.el-select{width:120px;padding-right:10px;}
        /deep/.el-input__inner{
            background:#212325;color:#fff;
        }
        .time{
            padding-right:10px;font-size: 14px;;
        }
    }
    /* 验证码弹框样式 */
    .captcha-content {
        text-align: center;
    }
    
    .captcha-instruction {
        color: #ffffffff;
        margin-bottom: 5px;
        font-size: 14px;
    }
    
    .captcha-counter {
        color: #409EFF;
        font-weight: bold;
        margin-bottom: 15px;
    }
    
    .captcha-container {
        position: relative;
        margin: 0 auto 20px;
        border: 0px solid #EBEEF5;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        width: 400px;
        height: 175px;
    }
    
    .captcha-container img {
        display: block;
        width: 100%;
    }
    
    .markers-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
    
    .marker {
        position: absolute;
        width: 24px;
        height: 24px;
        background: rgba(0, 162, 255, 1);
        border: 2px solid rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }
    
    .marker-label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-weight: bold;
        font-size: 12px;
    }
    
    .captcha-actions {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
    }
    
    .captcha-error {
        color: #F56C6C;
        margin-top: 15px;
        font-size: 13px;
        height: 20px;
    }
    /deep/.captcha-dialog {
        width: 500px
    }
    /deep/.captcha-dialog .el-dialog__header {
        background-color: #383737ff;
        border-bottom: none;
    }
    
    /deep/.captcha-dialog .el-dialog__title {
        color: white;
    }
    /deep/.el-dialog__body {
        padding: 0;
        padding-bottom: 10px;
        background-color: #202020ff;
    }
    /deep/.el-icon-refresh-left {
        font-size: 25px;
        color: #d3d1d1ff
    }
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue